/**
 * コーディングテストの模擬試験 (/interview-questions/coding/coding-test/mock)。ログイン無しで開ける。
 * 60 分で 2 問 (やさしい 1 問とふつう 1 問)。1 問ずつ提出して、全部のテストに通ったかで数え、終わったら結果とスキルチェックのランクの目安を出す。
 * 時計と結果は手元のブラウザ (localStorage) だけ。loader が返すのは組を作るための問題の一覧だけで、本文も隠れたテストも入れない。
 * 入口からのリンクは、説明の頁を直している別の担当の PR で足す (ここでは足さない)
 */
import { useLoaderData } from "react-router";
import type { MetaFunction } from "react-router";
import { MockExam } from "@/components/coding-test/MockExam";
import { CODING_INDEX_PATH } from "@/lib/coding-interview";
import { CODING_TEST_INDEX_PATH } from "@/lib/coding-test";
import { CODING_TEST_PROBLEMS } from "@/lib/coding-test.server";
import { generateLabSEOMeta } from "@/lib/seo-config";
import { generateBreadcrumbSchema } from "@/lib/structured-data";

const SITE = "https://yumesaku.tech";
const URL = `${SITE}${CODING_TEST_INDEX_PATH}/mock`;

export function loader() {
  return {
    problems: CODING_TEST_PROBLEMS.map((p) => ({ slug: p.slug, title: p.title, tier: p.tier, estimatedMinutes: p.estimatedMinutes, order: p.order })),
  };
}

export const meta: MetaFunction = () => [
  ...generateLabSEOMeta({
    title: "コーディングテストの模擬試験｜60 分で 2 問",
    description: "標準入力を読んで標準出力に書く形の問題を、本番と同じ 60 分で 2 問解く模擬試験です。1 問ずつ提出し、全部のテストに通ったかで数えます。結果は手元のブラウザにだけ残ります。",
    url: URL,
    canonicalUrl: URL,
  }),
  {
    "script:ld+json": generateBreadcrumbSchema([
      { name: "ホーム", url: SITE },
      { name: "技術面接問題", url: `${SITE}/interview-questions` },
      { name: "コーディング面接問題", url: `${SITE}${CODING_INDEX_PATH}` },
      { name: "コーディングテスト", url: `${SITE}${CODING_TEST_INDEX_PATH}` },
      { name: "模擬試験", url: URL },
    ]),
  },
];

export default function CodingTestMockPage() {
  const { problems } = useLoaderData<typeof loader>();
  return <MockExam problems={problems} />;
}
